<template>
  <van-popup 
    v-model="isVisible"
    closeable
    class="poster-dialog">
    <div class="dialog-content">
      <div class="img-box">
        <van-image v-if="imgData"
          width="100%"
          height="auto"
          fit="contain"
          :src="imgData"
        />
      </div>
      <div class="tips" v-if="isInWX">请长按图片后选择保存</div>
      <div class="down-btn" v-else @click="download">下载到相册</div>
    </div>
  </van-popup>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
import { isInWX } from '@/utils/utils'
import { saveToAlbum } from '@/utils/native-funs'
export default {
  mixins: [loadingMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    posterData: Object,
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    isInWX() {
      return isInWX()
    }
  },
  data() {
    return {
      imgData: null
    }
  },
  methods: {
    getPosterImg() {
      // 查询海报图片
      this.showLoading();
      this.$api.activityMgmt.getPosterWithCode(this.posterData)
        .then(({data}) => {
          if (data) {
            this.imgData = `data:image/jpeg;base64,${data}`
          }
        }).finally(_=>{
          this.hideLoading();
        })
    },
    download() {
      saveToAlbum(this.imgData)
    }
  },
  created() {
    this.getPosterImg();
  }
}
</script>

<style lang="stylus" scoped>
.poster-dialog
  width 80vw
  border-radius: 12px
  >>> .dialog-content
    .img-box
      display: flex
      min-height: 60vh
      max-height: 80vh
      overflow-y auto
      font-size 0
    .tips
      padding 10px 15px
      color red
      text-align: center
     .down-btn 
      width: 140px;
      height: 38px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 38px;
      background: linear-gradient(180deg, #FF8820 0%, #FF6B31 100%);
      border-radius: 22px;
      margin: 10px auto
</style>